// extracted by mini-css-extract-plugin
module.exports = {"container":"sidebar-module--container--1BIn3","dp":"sidebar-module--dp--1AxBg","extLinks":"sidebar-module--extLinks--2AvOS"};